import { render, staticRenderFns } from "./FormBuckets.vue?vue&type=template&id=7f44850e&"
import script from "./FormBuckets.vue?vue&type=script&lang=js&"
export * from "./FormBuckets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports